import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { formatDate, formatCurrency } from '../../utils/numberFormatter';
import {
  getApprovalStatusClass,
  getApprovalStatusLabel,
} from '../../utils/saleStatusAdapter';
import { getSaleLoanIdentifierDisplay } from '../../utils/saleLoanIdentifier';
import { ApprovalStatusColumnHeader } from '../../components/Sales/SaleStatusColumnHeaders';

const SalesListTable = ({
  sales,
  loading,
  pagination,
  showBranchColumn = false,
  onViewDetail,
  onGoToCustomer,
}) => {
  const columnCount = showBranchColumn ? 10 : 9;

  const TableSkeleton = () => (
    <>
      {Array.from({ length: pagination.per_page }).map((_, index) => (
        <tr key={index}>
          <td><Skeleton width={40} height={30} /></td>
          <td><Skeleton width={80} height={30} /></td>
          {showBranchColumn && <td><Skeleton width={60} height={30} /></td>}
          <td><Skeleton width={60} height={30} /></td>
          <td><Skeleton width={60} height={30} /></td>
          <td><Skeleton width={60} height={30} /></td>
          <td><Skeleton width={60} height={30} /></td>
          <td className="text-center"><Skeleton width={50} height={25} /></td>
          <td><Skeleton width={70} height={30} /></td>
          <td><Skeleton width={80} height={30} /></td>
        </tr>
      ))}
    </>
  );

  return (
    <table className="table table-hover">
      <thead>
        <tr>
          <th>N° Prestamo</th>
          <th>Cliente</th>
          {showBranchColumn && <th>Sucursal</th>}
          <th>Fecha</th>
          <th>Vendedor</th>
          <th>Monto</th>
          <th>Cuotas</th>
          <ApprovalStatusColumnHeader />
          <th>Fecha Liquidación</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <TableSkeleton />
        ) : sales.length === 0 ? (
          <tr>
            <td colSpan={columnCount} className="text-center text-muted py-5">
              <i className="bi bi-inbox rg-empty-icon-lg"></i>
              <p className="mt-3 mb-0">No hay ventas para mostrar</p>
            </td>
          </tr>
        ) : (
          sales.map((sale) => (
            <tr key={sale.id}>
              <td>{getSaleLoanIdentifierDisplay(sale)}</td>
              <td>
                <button
                  type="button"
                  onClick={() => onGoToCustomer(sale.customer.dni)}
                  className="rg-link-button"
                >
                  {sale.customer.name}
                </button>
                <br />
                <small className="text-muted">
                  DNI: {sale.customer.dni}
                </small>
              </td>
              {showBranchColumn && <td>{sale.branch?.name || '—'}</td>}
              <td>{formatDate(sale.sale_date)}</td>
              <td>{sale.seller?.full_name || '—'}</td>
              <td>{formatCurrency(sale.amount)}</td>
              <td className="text-center">{sale.installments}</td>
              <td className="text-center">
                <span className={`sale-status-badge ${getApprovalStatusClass(sale)}`}>
                  {getApprovalStatusLabel(sale)}
                </span>
              </td>
              <td>
                {sale.settlement_date ? formatDate(sale.settlement_date) : (
                  <span className="text-muted">—</span>
                )}
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => onViewDetail(sale.id, sale.customer.id)}
                  title="Ver detalle"
                >
                  <i className="bi bi-eye me-1"></i>
                  Ver
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default SalesListTable;
